import React, { useRef, useState } from 'react';
import { spacing01 } from '../../../../styling/spacing';
import { IconButton } from '../DeleteAndDuplicateButtons';
import { PopoverMenu, PopoverOption } from '../../../../shared/PopoverMenu';
import styled from 'styled-components/macro';

type Props = {
  tooltipLabel: string;
  icon: JSX.Element;
  options: Array<PopoverOption>;
  onMenuOpen?: () => void;
  onClickAway?: () => void;
  testId?: string;
  className?: string;
};

export const Popover = ({ tooltipLabel, icon, options, onMenuOpen, onClickAway, testId, className }: Props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleMenuOpen = () => {
    onMenuOpen?.();
    setPopoverVisible(true);
  };

  const handleMenuClose = () => {
    if (buttonRef.current && !(buttonRef.current.getAttribute('called') === 'true')) {
      onClickAway?.();
    } else if (buttonRef.current) {
      buttonRef.current.setAttribute('called', '');
    }
    setPopoverVisible(false);
  };

  const handleAfterSelectMenuItem = () => {
    if (buttonRef.current) {
      buttonRef.current.setAttribute('called', 'true');
      buttonRef.current.blur();
    }
  };

  return (
    <>
      <PopoverButton
        onClick={handleMenuOpen}
        onBlur={handleMenuClose}
        title={tooltipLabel}
        data-testid={testId}
        className={className}
        ref={buttonRef}
      >
        {icon}
      </PopoverButton>
      <PopoverMenu
        isVisible={popoverVisible}
        options={options}
        onAfterSelectMenuItem={handleAfterSelectMenuItem}
        closeMenu={() => setPopoverVisible(false)}
      />
    </>
  );
};

const PopoverButton = styled(IconButton)`
  padding: 0;
  margin: 2px 0 0 ${spacing01};
  height: 28px;
  width: 28px;
`;
